import React, { useState, useEffect } from "react";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import "./style.css";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";
import ContactForm from "./components/ContactForm";
import PageTransition from "./components/PageTransition";
import GrainOverlay from "./components/GrainOverlay";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BlogList from "./components/Blog/BlogList";
import BlogPost from "./components/Blog/BlogPost";
import AILandscape from "./components/Landscape/AILandscape";
import Memo from "./components/Thesis/Thesis";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <GrainOverlay />
      <CustomCursor />
      <Router>
        <Preloader load={load} />
        <div className="App" id={load ? "no-scroll" : "scroll"}>
          <Navbar />
          <ScrollToTop />
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route
                path="/contact"
                element={
                  <div style={{ padding: "4rem 1rem", textAlign: "center" }}>
                    <h1>Contact Me</h1>
                    <ContactForm />
                  </div>
                }
              />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/landscape" element={<AILandscape />} />
              <Route path="/memo" element={<Memo />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </PageTransition>
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
